import React from 'react';
export var AppHorizontalLine = function (_a) {
    var className = _a.className;
    return (React.createElement("hr", { className: "horizontal-line " + className }));
};
//# sourceMappingURL=app-horizontal-line.js.map